import { render, staticRenderFns } from "./WaveformV2.vue?vue&type=template&id=42e1cc97&scoped=true"
import script from "./WaveformV2.vue?vue&type=script&lang=js"
export * from "./WaveformV2.vue?vue&type=script&lang=js"
import style0 from "./WaveformV2.vue?vue&type=style&index=0&id=42e1cc97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1cc97",
  null
  
)

export default component.exports